import React from 'react';
import View from 'styleguide/View/View';
import './CircleIcon.scss';

export default function CircleIcon(props: React.PropsWithChildren<Record<string, unknown>>) {
  return <View className="CircleIcon">{props.children}</View>;
}
